import React from "react";
import { WcStack, WcButton, WcTypography } from "@bpipartners/webui";
import { useTranslations } from "next-intl";
import { MdArrowBack } from "react-icons/md";
import { useRouter } from "next/navigation";

const PasswordSentComposite = ({
  setIsSubmitted,
  setFailedReset,
}: {
  setIsSubmitted: (val: boolean) => void;
  setFailedReset: (val: boolean) => void;
}) => {
  const t = useTranslations("login");
  const router = useRouter();

  return (
    <WcStack alignItems="center" justifyContent="center" height="100%" gap={5} p={5}>
      <WcTypography variant="body2" sx={{ textAlign: "justify" }}>
        {t("passwordResetEmailSent")}
      </WcTypography>
      <WcTypography variant="body1" sx={{ textAlign: "justify", fontWeight: "bold" }}>
        {t("passwordResetNoEmailQuestion")}
      </WcTypography>
      <WcTypography variant="body2" sx={{ textAlign: "justify" }}>
        {t("passwordResetNoEmail")}
      </WcTypography>
      <WcButton
        variant="contained"
        color="primary"
        sx={{ mt: 2 }}
        onClick={() => {
          window.location.href = "/login";
        }}
        startIcon={<MdArrowBack />}
      >
        {t("back2login")}
      </WcButton>
    </WcStack>
  );
};

export default PasswordSentComposite;
